import { render } from "./NoteContextMenu.vue?vue&type=template&id=b50301ee"
import script from "./NoteContextMenu.vue?vue&type=script&lang=js"
export * from "./NoteContextMenu.vue?vue&type=script&lang=js"

import "./NoteContextMenu.vue?vue&type=style&index=0&id=b50301ee&lang=css"

import exportComponent from "/var/www/service/service-cp-company/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__